import React, {FC, useEffect} from 'react';
import MatchListItem, {MatchListItemProps} from '../../Common/MatchListItem';
import {isLiveMatch} from '../../../utils/matchFns';
import usePolling from '../../../hooks/usePolling';
import getConfig from '../../../getConfig';
import useMatchesActions from '../../../hooks/useMatchesActions';

const {pollingRates} = getConfig();

/**
 * Handles the live events polling business logic and then passes all the received props down
 * to a MatchListItem component.
 */
const AsyncMatchListItem: FC<MatchListItemProps> = (props: MatchListItemProps) => {
  const {match, ...rest} = props;
  const {withPolling} = usePolling();
  const {getLiveMatchScoreById} = useMatchesActions();
  const repeatLiveMatchScoreById = withPolling(getLiveMatchScoreById, pollingRates.liveMatches, false);

  useEffect(() => {
    if (isLiveMatch(match)) {
      repeatLiveMatchScoreById(match._id, match.date);
    }

    return repeatLiveMatchScoreById.cancel;
  }, [match, repeatLiveMatchScoreById]);

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <MatchListItem match={match} {...rest} />;
};

export default React.memo(AsyncMatchListItem);
